function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Container, Heading } from '../../atoms';
export default function ContactSection(param) {
    var title = param.title, description = param.description, children = param.children, formProps = param.formProps, successState = param.successState;
    return /*#__PURE__*/ React.createElement(Container, {
        name: ContactSection.name
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-sm mx-auto bg-bg-subtle rounded-2xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 p-6 md:p-7"
    }, !!(title || description) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-5"
    }, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description)), !successState && /*#__PURE__*/ React.createElement("form", _object_spread({
        className: twMerge('grid grid-cols-1 grid-flow-row auto-rows-max gap-6', formProps === null || formProps === void 0 ? void 0 : formProps.className)
    }, formProps), children), !!successState && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-2 text-center py-10"
    }, !!successState.title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, successState.title), !!successState.description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, successState.description)))));
}

//# sourceMappingURL=ContactSection.js.map